<template>
  <div>
    <loader v-if="isLoading"></loader>
    <fetch-error
      v-else-if="settingsData instanceof FetchError"
      @retry="fetchData()"
      :error="settingsData"
    >
    </fetch-error>
    <template v-else>
      <page-title
        heading="تنظیمات مجموعه"
        subHeading="میتوانید تنظیمات مورد نظر خود را از طریق زیر اعمال کنید."
      />
      <vs-row class="m-0 p-0">
        <vs-col
          v-for="(settingItem, index) in settingsData"
          :key="index"
          class="m-0 p-3"
          :vs-lg="settingItem.lg"
          :vs-sm="settingItem.sm"
        >
          <vx-card :title="settingItem.title">
            <div slot="no-body" class="pt-5">
              <div v-for="data in settingItem.data" :key="data.id">
                <theme-settings
                  v-if="settingItem.id === 'theme'"
                  :item="data"
                  :themes="themes"
                />
                <vs-col
                  v-else-if="data.type === 'receiveNotifSound'"
                  vs-lg="6"
                  vs-sm="12"
                  vs-xs="12"
                  style="float: right"
                  class="mb-8"
                >
                  <vs-checkbox v-model="receiveNotifSound"
                    >دریافت صدای نوتیفکیشن در پنل</vs-checkbox
                  >
                </vs-col>
                <setting-item v-else :item="data" />
              </div>
            </div>
          </vx-card>
        </vs-col>
      </vs-row>
    </template>
  </div>
</template>

<script>
  import productApiService from "../../services/api/ProductApiService";
  import FetchError from "../../services/api/FetchError";
  import { mapGetters } from "vuex";
  import VxCard from "../../components/VxCard.vue";
  import SettingItem from "./SettingItem.vue";
  import PageTitle from "../../components/pageTitle/PageTitle.vue";
  import ThemeSettings from "./ThemeSettings.vue";
  import providerApiService from "../../services/api/ProviderApiService";

  export default {
    components: { VxCard, SettingItem, PageTitle, ThemeSettings },
    data() {
      return {
        settingsData: [],
        receiveNotifSound: true,
        themes: [],
        FetchError,
      };
    },
    computed: {
      ...mapGetters({
        currentProvider: "profile/currentProvider",
      }),
      isLoading() {
        return (
          (Array.isArray(this.settingsData) &&
            this.settingsData.length === 0) ||
          (Array.isArray(this.themes) && this.themes.length === 0)
        );
      },
    },
    methods: {
      getReceiveNotifSoundCheck() {
        // ReceiveNotifSound should be false only When canReceive is false.
        this.receiveNotifSound = !(
          JSON.parse(localStorage.getItem("receiveNotifSound")) === false
        );
      },
      fetchData() {
        this.settingsData = [];
        productApiService
          .shopSettings(this.currentProvider.id)
          .then((res) => this.setGroupBySettingsData(res.data))
          .catch((err) => {
            this.settingsData = err;
          });
      },
      fetchProviderThemes() {
        this.themes = [];
        providerApiService
          .themes()
          .then((res) => {
            this.themes = res.data;
          })
          .catch((err) => {
            this.themes = err;
          });
      },
      setGroupBySettingsData(data) {
        const typePriority = {
          integer: 1,
          string: 2,
        };

        const sortSettingsByType = (items) => {
          return [...items].sort((a, b) => {
            const aPriority = typePriority[a.type] || 3;
            const bPriority = typePriority[b.type] || 3;

            if (aPriority === bPriority) {
              return a.id - b.id;
            }

            return aPriority - bPriority;
          });
        };

        const groups = {
          theme: {
            id: "theme",
            title: "پوسته اپلیکیشن",
            data: [],
            lg: 12,
            sm: 12,
          },
          orders: { id: "orders", title: "سفارشات", data: [], lg: 12, sm: 12 },
          account: { id: "account", title: "اکانت", data: [], lg: 6, sm: 12 },
          notifications: {
            id: "notifications",
            title: "اعلان ها",
            data: [],
            lg: 6,
            sm: 12,
          },
        };

        data?.forEach((item) => {
          if (groups[item.group]) {
            groups[item.group].data.push(item);
          }
        });

        groups.notifications.data.push({
          id: 999,
          type: "receiveNotifSound",
        });

        Object.values(groups).forEach((group) => {
          group.data = sortSettingsByType(group.data);
        });

        const orderedGroups = ["theme", "orders", "account", "notifications"];

        this.settingsData = orderedGroups
          .map((key) => groups[key])
          .filter((group) => group.data.length > 0);
      },
    },
    watch: {
      receiveNotifSound(value) {
        localStorage.setItem("receiveNotifSound", value);
        this.$vs.notify({
          text: value ? "صدای نوتفیکیشن وصل شد." : "صدای نوتیفیکشن قطع شد.",
          color: "success",
          position: "bottom-center",
        });
      },
    },
    mounted() {
      this.fetchData();
      this.getReceiveNotifSoundCheck();
      this.fetchProviderThemes();
    },
  };
</script>

<style lang="scss">
  .radio {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .radio-btn {
    margin: 0 10px;
  }

  .radio-title {
    margin: 0 10px;
  }
</style>
